export type BudgetCategoryKey = 'cat1' | 'cat2' | 'cat3' | 'cat4';

export type BudgetNoteCategoryHeaderLabels = Record<BudgetCategoryKey, string>;

export const BUDGET_CATEGORY_KEYS: BudgetCategoryKey[] = ['cat1', 'cat2', 'cat3', 'cat4'];

export const DEFAULT_BUDGET_NOTE_CATEGORY_HEADER_LABELS: BudgetNoteCategoryHeaderLabels = {
  cat1: '카테고리1',
  cat2: '카테고리2',
  cat3: '카테고리3',
  cat4: '카테고리4',
};

function normalizeLabel(value: unknown, fallback: string): string {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed) return trimmed;
  }
  return fallback;
}

export function normalizeBudgetNoteCategoryHeaderLabels(
  input: Partial<BudgetNoteCategoryHeaderLabels> | null | undefined
): BudgetNoteCategoryHeaderLabels {
  return {
    cat1: normalizeLabel(input?.cat1, DEFAULT_BUDGET_NOTE_CATEGORY_HEADER_LABELS.cat1),
    cat2: normalizeLabel(input?.cat2, DEFAULT_BUDGET_NOTE_CATEGORY_HEADER_LABELS.cat2),
    cat3: normalizeLabel(input?.cat3, DEFAULT_BUDGET_NOTE_CATEGORY_HEADER_LABELS.cat3),
    cat4: normalizeLabel(input?.cat4, DEFAULT_BUDGET_NOTE_CATEGORY_HEADER_LABELS.cat4),
  };
}

export function mapBudgetNoteCategoryHeaderLabelsFromDbRow(row: {
  cat1_label?: string | null;
  cat2_label?: string | null;
  cat3_label?: string | null;
  cat4_label?: string | null;
}): BudgetNoteCategoryHeaderLabels {
  return normalizeBudgetNoteCategoryHeaderLabels({
    cat1: row.cat1_label ?? undefined,
    cat2: row.cat2_label ?? undefined,
    cat3: row.cat3_label ?? undefined,
    cat4: row.cat4_label ?? undefined,
  });
}
